import EventEmitter from "./EventEmitter.js";
import * as THREE from "three";

export default class Time extends EventEmitter {
  constructor() {
    super();

    // Setup
    this.start = Date.now();
    this.clock = new THREE.Clock();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = 16;

    window.requestAnimationFrame(() => {
      this.tick();
    });
  }

  tick() {
    const currentTime = Date.now();
    // Clamp so a long pause (e.g. a background tab) doesn't skip animations ahead
    this.delta = Math.min(currentTime - this.current, 100);
    this.current = currentTime;
    this.elapsed = this.current - this.start;
    this.elapsedTime = this.clock.getElapsedTime();

    this.trigger("tick");

    window.requestAnimationFrame(() => {
      this.tick();
    });
  }
}
